<template>
  
                <div v-if="gene_xpert" class="card card-content">
                    
                   <h6 >Gene Xpert</h6>
                      <form >
                         <div class="row">
                            <div class="input-field col s12">
                            
                              <div class="switch">
                                    <label>
                                    Not Done
                                    <input type="checkbox"  
                                        @click="switchChange"
                                        :checked="gene_xpert.done==1"
                                    >
                                    <span class="lever"></span>
                                     Done
                                    </label>
                                </div>

                            
                            </div>
                           <div class="input-field col s12">
                            <span>Date of Gene Xpert examination</span>
                            <input   type="text"  placeholder="YYYY-MM-DD" 
                                v-model.lazy="gene_xpert.date" class="datepicker"
                                :disabled="gene_xpert.done!=1" 
                                readonly
                                >
                            
                            </div>
                            <div class="input-field col s12" v-show="gene_xpert.done==1">
                            <span>Result of Gene Xpert</span>
                             <select v-model="gene_xpert.result" >
                                <option value="" disabled selected>Choose your option</option>
                                <option value="1" >N-MTB not detected</option>
                                <option value="2" >T-MTB detected</option>
                                <option value="3" >RR-Rif resistance</option>
                                <option value="4" >Tl-MTB detected, RR indeterminate</option>
                                <option value="5" >l-invalid result</option>
                                <option value="6" >Missing</option>
                                </select>

                            
                            </div>
                            

                            
                            <div class="row center" v-if="buttonpass">
                                <button type="button" class="btn blue darken-3"
                                    @click="submit" :disabled="updateloading"
                                >Edit</button>
                            </div>
                            
                        </div>
                    </form>
                 
                </div>
                <new-gene-xpert v-else></new-gene-xpert>
</template>

<script>
import NewGeneXpert from '@/components/Patient/Fill/GeneXpert/NewGeneXpert.vue';
export default {
  name: 'GeneXpert',
  data () {
    return {
        done:false,
        date:"",
        result:"",
       
    }
  },
  components: {
    "new-gene-xpert":NewGeneXpert
  },
  mounted()
  {
      
     var elems = document.querySelectorAll('select');
    var instances = M.FormSelect.init(elems, {});

    var elems = document.querySelectorAll('.datepicker');
    var instances = M.Datepicker.init(elems, {
        format:"yyyy-mm-dd",
        showClearBtn: true
    });
     
  },
  watch:{
  
} ,
  methods: {
  

  switchChange()
  {
      this.gene_xpert.done=this.gene_xpert.done==0?1:0;
      
  },

  submit()
  {
      var data={
          done:this.gene_xpert.done,
          date:null,
          result:null
      };

      if (data.done)
      {
          data.date=this.gene_xpert.date;
          data.result=this.gene_xpert.result;
      }

      data.id=this.patient.id;

      this.$store.dispatch("submitGeneExpert",data);
      
  }

  
  },
 
  computed:
  {
    patient()
        {
            
            return this.$store.getters.patient;
        },

    gene_xpert()
    {
        var item=localStorage.getItem("current_data");
        var data=this.$store.getters.patient.gene_xpert;
        if (!item)
        {
            localStorage.setItem("current_data",JSON.stringify(data));
        }

        return data;
    },

    buttonpass()
    {
        if (this.gene_xpert.done==1)
        {
            if (this.gene_xpert.result && this.gene_xpert.date)
            {
                return true;
            }
            else 
            {
                return false;
            }
        }
        else 
        {
            return true;
        }
    },
    updateloading()
    {
        return this.$store.getters.updateloading;
    },
  },


  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .fill 
  {
      padding-left:20px;
      padding-right:20px;
      padding-top:5px;
  }

  .fill .card 
  {
      padding:20px;
  }
 



  

   
</style>
